<template>
	<div :class="tabClass">

		<div class="tab-content" v-if="pos === 'right'">
			<slot></slot>
		</div>

		<ul :class="{ 'nav nav-tabs nav-tabs-highlight': true, 'nav-justified': justify }" ref="ul">

			<li v-show="tab.isShown" v-for="(tab, index) in tabs" :class="{ 'active': tab.isActive }">
				<a href="#" v-html="tab.name" @click.prevent="selectTab(tab)"></a>
			</li>

		</ul>

		<div class="tab-content" v-if="pos === 'left'">
			<slot></slot>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: String,
				default: 'horizontal'
			},
			pos: {
				type: String,
				default: 'left'
			},
			justify: {
				type: Boolean,
				default: false
			},
			sticky: {
				type: Boolean,
				default: false
			},
			relativeElementSelector: {
				type: String,
				default: '.container'
			},
			topOffset: {
				default: 145
			}
		},
		created() {
			this.tabs = this.$children;
		},
		mounted() {
			if (this.sticky) {
				$(this.$refs.ul).stick_in_parent()
					.on('sticky_kit:stick', (e) => {
						$(this.$refs.ul).css({'z-index': '9999', 'top': `${this.topOffset}px`, 'background': '#eee'});
					})
					.on('sticky_kit:unstick', (e) => {
						$(this.$refs.ul).css({'z-index': '0', 'top': '0', 'background': 'transparent'});
					});
			}
		},
		data() {
			return {
				tabs: [],
			};
		},
		computed: {
			tabClass() {
				let classes = [ 'tabbable' ];

				if (this.type === 'horizontal') {
					classes.push('nav-tabs-horizontal');
				} else {
					classes.push('nav-tabs-vertical');
					classes.push('nav-tabs-' + this.pos);
				}

				return classes;
			},

			/**
			 * Computes the relative element selector to a selector.
			 */
			relativeElement() {
				return document.querySelector(this.relativeElementSelector);
			}
		},
		methods: {
			/**
			 * Set active tab.
			 *
			 * @param selectedTab
			 */
			selectTab(selectedTab) {
				this.$emit('tabSelected', selectedTab);

				if (! selectedTab.isTab) {
					return;
				}

				this.tabs.forEach(tab => {
					tab.isActive = (tab === selectedTab);
				});
			},
		}
	}
</script>